import { IoIosClose } from "react-icons/io";
import { MdAccessTime } from "react-icons/md";

import { colorClassForNotificationPopOver } from "./Notifications.utils";

export default function NotificationItem({ notify, callUpdate }) {
  return (
    <div className={`notification-item ${colorClassForNotificationPopOver[notify?.status]}`}>
      <div className="d-inline-flex d-flex justify-content-between w-100">
        <button
          type="button"
          className="notification-message"
          onClick={() => callUpdate(notify?.notificationId, false)}
        >
          {notify?.message}
        </button>

        <div className="d-flex justify-content-end">
          <button
            type="button"
            className="notification-close-button"
            onClick={() => callUpdate(notify?.notificationId)}
          >
            <IoIosClose size="18px" className="notification-close-icon" />
          </button>
        </div>
      </div>

      <div className="notification-details">
        <div className="notification-time">
          <MdAccessTime size="14px" className="notification-icon-detail" />
          <span>{notify?.createdAt}</span>
        </div>
      </div>
      <p className="noti-line"></p>
    </div>
  );
}
